<template>
  <q-card flat bordered>
    <div
      class="q-pa-sm text-subtitle1 text-weight-medium"
      :class="this.$q.dark.mode === true ? '' : ' text-primary'"
    >
      Individual Report : Cumm Profit
      {{ signalsCumulativeProfit.toFixed(2) }} %
    </div>
    <q-separator />
    <q-table
      :rows="signals"
      :columns="columns"
      binary-state-sort
      separator="cell"
      :pagination="pagination"
      class="no-padding"
      dense
      :class="
          $q.dark.mode
            ? 'table-sticky-header-column-dark'
            : 'table-sticky-header-column'
        "
    >
    </q-table>

    <!-- <q-table
      hide-header
      :dense="$q.screen.lt.md"
      :pagination="pagination"
      :rows="signals"
      :columns="colDefSignals"
      row-key="name"
      style="height: 300px"
    >
      <template v-slot:top>
        <q-space />
        <q-chip
          class="q-pa-sm text-caption text-weight-bold"
          icon="warning"
          color="red-7"
          text-color="white"
          style="height: 24px; width: auto"
        >
          Stop Loss
        </q-chip>
        <q-chip
          class="q-pa-sm text-caption text-weight-bold"
          icon="flag"
          color="green-7"
          text-color="grey-3"
          style="height: 24px; width: auto"
        >
          Profit Target
        </q-chip>
      </template>
      <q-separator />
      <template v-slot:body="props">
        <q-tr :props="props" :key="`e_${props.row.id}`">
          <q-td v-if="props.row.buy_date" auto-width>
            <q-badge
              text-color="white"
              color="green-6"
              class="text-caption text-weight-bold q-pa-xs"
            >
              Buy on {{ props.row.buy_date }} @ &nbsp;
              <q-badge
                color="green-9"
                class="text-caption text-weight-bold q-pa-xs"
              >
                Rs.{{ props.row.buy_price.toFixed(2) }}
              </q-badge>
            </q-badge>
          </q-td>
          <q-td v-else auto-width class="text-primary text-italic">
            Not Generated Yet
          </q-td>

          <q-td v-if="props.row.sell_date" auto-width>
            <q-badge
              text-color="white"
              color="red-6"
              class="text-caption text-weight-bold q-pa-xs"
            >
              Sell on {{ props.row.sell_date }} @ &nbsp;
              <q-badge
                color="red-9"
                class="text-caption text-weight-bold q-pa-xs"
              >
                Rs.{{ props.row.sell_price.toFixed(2) }}
              </q-badge>
            </q-badge>
            <q-chip
              class="q-pa-sm text-caption text-weight-bold"
              icon="warning"
              color="red-7"
              text-color="grey-3"
              style="height: 24px; width: auto"
            >
              {{ props.row.stop_loss?.toFixed(2) }}
            </q-chip>
          </q-td>
          <q-td v-else auto-width class="text-primary text-italic">
            Not Generated Yet

            <q-chip
              class="q-pa-sm text-caption text-weight-bold"
              icon="warning"
              color="red-7"
              text-color="grey-3"
              style="height: 24px; width: auto"
            >
              {{ props.row.stop_loss?.toFixed(2) }}
            </q-chip>
          </q-td>
          <q-td
            v-if="
              props.row.profit_percentage != null &&
              props.row.profit_percentage != undefined
            "
            auto-width
          >
            <q-badge
              text-color="white"
              :color="
                props.row.profit_percentage === 0
                  ? 'blue-6'
                  : props.row.profit_percentage < 0
                  ? 'red-6'
                  : 'green-6'
              "
              class="text-caption text-weight-bold q-pa-xs"
            >
              {{
                props.row.profit_percentage === 0
                  ? "Breakeven"
                  : props.row.profit_percentage < 0
                  ? "Loss of " + props.row.profit_percentage.toFixed(2) + "%"
                  : "Profit of " + props.row.profit_percentage.toFixed(2) + "%"
              }}
            </q-badge>
            <q-chip
              class="q-pa-sm text-caption text-weight-bold"
              icon="flag"
              color="green-7"
              text-color="grey-3"
              style="height: 24px; width: auto"
            >
              {{ props.row.profit_target?.toFixed(2) }}
            </q-chip>
          </q-td>
          <q-td v-else auto-width class="text-primary text-italic">
            Not Generated Yet

            <q-chip
              class="q-pa-sm text-caption text-weight-bold"
              icon="flag"
              color="green-7"
              text-color="grey-3"
              style="height: 24px; width: auto"
            >
              {{ props.row.profit_target?.toFixed(2) }}
            </q-chip>
          </q-td>
        </q-tr>
      </template>
    </q-table> -->
    <DisclaimerMessage short />
  </q-card>
</template>

<script>
import { ref, watch } from "vue";
import useData from "src/use/data";
import DisclaimerMessage from "src/components/DisclaimerMessage.vue";
export default {
  name: "ConfirmSignal",
  props: ["symbol", "searchSymbol", "weekly", "intraday"],
  components: { DisclaimerMessage },
  setup(props) {
    const searchText = ref(props.symbol);
    let isStockProfile = ref(false);
    const searchedStock = ref(null);

    let showStockProfileTable = ref(false);
    let stockProfileTable = ref([]);

    let signals = ref([]);
    let sellSignalsData = [];
    let buySignalsData = [];
    let signalsCumulativeProfit = ref(0);

    const { buySellSearch, buySellSearchWeekly } = useData();
    const colDefSignals = [
      {
        name: "buy_at_price",
        label: "Buy At Price",
        required: true,
        sortable: true,
        field: (row) => row.buy_date,
        sortOrder: "da", // or 'ad'
        sort: (a, b, rowA, rowB) => Date.parse(a) - Date.parse(b),
        align: "center",
      },
      {
        name: "sell_at_price",
        label: "Sell At Price",
        required: true,
        sortable: true,
        align: "center",
      },
      {
        name: "profit_percentage",
        label: "Profit %",
        required: true,
        sortable: true,
        align: "center",
      },
    ];

    const columns = [
      {
        name: "buy_date",
        label: "Buy Date",
        field: "buy_date",
        sortable: true,
        align: "center",
        style: (row) => {
          return row.profit_percentage == null
            ? ""
            : parseFloat(row.profit_percentage) > 0
            ? "color:green;"
            : "color:red;";
        },
      },
      {
        name: "buy_price",
        label: "Buy Price",
        field: "buy_price",
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        sortable: true,
        align: "center",
        style: (row) => {
          return row.profit_percentage == null
            ? ""
            : parseFloat(row.profit_percentage) > 0
            ? "color:green;"
            : "color:red;";
        },
      },
      {
        name: "sell_date",
        label: "Sell Date",
        field: "sell_date",
        sortable: true,
        align: "center",
        format: (val, row) => {
          return val == null ? "waiting" : val;
        },
        style: (row) => {
          return row.profit_percentage == null
            ? ""
            : parseFloat(row.profit_percentage) > 0
            ? "color:green;"
            : "color:red;";
        },
      },
      {
        name: "sell_price",
        label: "Sell Price",
        field: "sell_price",
        sortable: true,
        align: "center",
        format: (val, row) => {
          return val == null ? "waiting" : parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return row.profit_percentage == null
            ? ""
            : parseFloat(row.profit_percentage) > 0
            ? "color:green;"
            : "color:red;";
        },
      },
      {
        name: "profit_percentage",
        label: "Profit %",
        field: "profit_percentage",
        format: (val, row) => {
          return val == null ? "-" : parseFloat(val).toFixed(2);
        },
        sortable: true,
        align: "center",
        style: (row) => {
          return row.profit_percentage == null
            ? ""
            : parseFloat(row.profit_percentage) > 0
            ? "color:green;"
            : "color:red;";
        },
      },
      {
        name: "stop_loss",
        label: "Stop Loss",
        field: "stop_loss",
        format: (val, row) => {
          return val == null ? "-" : parseFloat(val).toFixed(2);
        },
        sortable: true,
        align: "center",
        style: (row) => {
          return row.profit_percentage == null
            ? ""
            : parseFloat(row.profit_percentage) > 0
            ? "color:green;"
            : "color:red;";
        },
      },
      {
        name: "profit_target",
        label: "Profit Target",
        field: "profit_target",
        format: (val, row) => {
          return val == null ? "-" : parseFloat(val).toFixed(2);
        },
        sortable: true,
        align: "center",
        style: (row) => {
          return row.profit_percentage == null
            ? ""
            : parseFloat(row.profit_percentage) > 0
            ? "color:green;"
            : "color:red;";
        },
      },
    ];
    const pagination = {
      sortBy: "buy_date",
      descending: true,
      rowsPerPage: 5,
    };
    const paginationStockProfileTable = {
      rowsPerPage: 100,
    };

    const generateSignalsTable = async (searchText) => {
      if (!searchText) {
        return
      }
      if (props.weekly) {
        await buySellSearchWeekly(searchText)
          .then((res) => {
            signals.value = res.data;
            signalsCumulativeProfit.value = signals.value.reduce(
              (acc, curr) => {
                return acc + curr.profit_percentage;
              },
              0
            );

            sellSignalsData = signals.value.map((item) => {
              return Array.from([Date.parse(item.sell_date), item.sell_price]);
            });

            buySignalsData = signals.value.map((item) => {
              return Array.from([Date.parse(item.buy_date), item.buy_price]);
            });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        await buySellSearch(searchText)
          .then((res) => {
            signals.value = res.data;
            signalsCumulativeProfit.value = signals.value.reduce(
              (acc, curr) => {
                return acc + curr.profit_percentage;
              },
              0
            );

            sellSignalsData = signals.value.map((item) => {
              return Array.from([Date.parse(item.sell_date), item.sell_price]);
            });

            buySignalsData = signals.value.map((item) => {
              return Array.from([Date.parse(item.buy_date), item.buy_price]);
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    };

    generateSignalsTable(props.symbol);

    watch(props, (newProps, oldProps) => {
      generateSignalsTable(newProps.symbol);
    });

    return {
      // v-ifs
      isStockProfile,
      showStockProfileTable,

      // stock data
      searchText,
      searchedStock,

      // signals data
      signals,
      signalsCumulativeProfit,

      colDefSignals,
      pagination,
      paginationStockProfileTable,
      columns,
    };
  },
};
</script>
